const generateImageUrl = ({ name, color, size }) => {
  const url = ['/icons']

  if (color) {
    url.push(color.toUpperCase())
  }

  if (size) {
    url.push(`${size[0]}x${size[1]}`)
  }

  url.push(`${name}.svg`)

  return url.join('/')
}

export default generateImageUrl
